import React, { useState, useEffect } from 'react'
import { Box, SimpleGrid, Text, Skeleton, Grid, Badge, Paper, Drawer, ActionIcon, Flex, NumberFormatter, Card, Group, ThemeIcon, Title, Tooltip, Switch } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { getDetailUser } from '../../../../services/users'
import { getDetailOrder, updateOrder } from '../../../../services/orders'
import { updateOrderGeneral } from '../../../../store/orderDetail'
import dayjs from 'dayjs'
import { shipmentMethod } from '../../../../helper/master-unit'
import { IconPencilMinus } from '@tabler/icons-react'
import FormAdjustOrderBy from './Form/FormAdjustOrderBy'
import FormAdjustAgent from './Form/FormAdjustAgent'
import FormAdjustSales from './Form/FormAdjustSales'
import FormAdjustAdditionalInfo from './Form/FormAdjustAdditionalInfo'
import FormAdjustPaymentStatus from './Form/FormAdjustPaymentStatus'
import FormAdjustOrderStatus from './Form/FormAdjustOrderStatus'
import FormAdjustGeneralInfo from './Form/FormAdjustGeneralInfo'
import FormAdjustOrderExcerpt from './Form/FormAdjustOrderExcerpt'
import { IconBox, IconCashBanknote, IconRosetteDiscount, IconPackage, IconWeight, IconShoppingCart, IconInfoCircle, IconWallet } from '@tabler/icons-react'
import { notificationSuccess, notificationError } from '../../../ui/Notifications'

let userMemoryCache = {}
let salesMemoryCache = {}

const defaultDataUser = {
  id: null,
  name: ''
}

const OrderSummary = () => {
  const dispatch = useDispatch()
  const { isLoadingOrder, summary, logistic, general, additionalInfo } = useSelector(state => state.order_detail)
  const [detailUser, setDetailUser] = useState(defaultDataUser)
  const [loadingUser, setLoadingUser] = useState(true)
  const [detailCreatedUser, setDetailCreatedUser] = useState(defaultDataUser)
  const [loadingCreatedUser, setLoadingCreatedUser] = useState(true)
  const [detailUpdatedUser, setDetailUpdatedUser] = useState(defaultDataUser)
  const [loadingUpdatedUser, setLoadingUpdatedUser] = useState(true)
  const [detailUserAgent, setDetailUserAgent] = useState(defaultDataUser)
  const [loadingUserAgent, setLoadingUserAgent] = useState(true)
  const [detailUserSales, setDetailUserSales] = useState(defaultDataUser)
  const [loadingUserSales, setLoadingUserSales] = useState(true)
  const [openEditOrderBy, setOpenEditOrderBy] = useState(false)
  const [openEditAgent, setOpenEditAgent] = useState(false)
  const [openEditSales, setOpenEditSales] = useState(false)
  const [openEditAdditionalInfo, setOpenEditAdditionalInfo] = useState(false)
  const [openEditPaymentStatus, setOpenEditPaymentStatus] = useState(false)
  const [openEditOrderStatus, setOpenEditOrderStatus] = useState(false)
  const [openEditGeneralInfo, setOpenEditGeneralInfo] = useState(false)
  const [openEditOrderExcerpt, setOpenEditOrderExcerpt] = useState(false)

  const getDataUser = async (userId) => {
    setLoadingUser(true)
    try {
      const response = await handleGetDetailUser(userId)
      setDetailUser(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUser(false)
    }
  }

  const getDataCreatedUser = async (userId) => {
    setLoadingCreatedUser(true)
    try {
      const response = await handleGetDetailUser(userId)
      setDetailCreatedUser(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCreatedUser(false)
    }
  }

  const getDataUpdatedUser = async (userId) => {
    setLoadingUpdatedUser(true)
    try {
      const response = await handleGetDetailUser(userId)
      setDetailUpdatedUser(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUpdatedUser(false)
    }
  }

  const getDataUserAgent = async (userId) => {
    setLoadingUserAgent(true)
    try {
      const response = await handleGetDetailUser(userId)
      setDetailUserAgent(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUserAgent(false)
    }
  }

  const getDataUserSales = async (orderId) => {
    if (salesMemoryCache[orderId]) {
      setDetailUserSales(salesMemoryCache[orderId])
      setLoadingUserSales(false)
      return
    }
    setLoadingUserSales(true)
    const params = {
      include: 'sales',
      'fields[order]': 'id',
    }
    try {
      const response = await getDetailOrder(orderId, params)
      const relationships = response.data.relationships
      let remapDataSales;
      if ('sales' in relationships) {
        const salesById = relationships.sales.id || null
        const salesByName = response.included.sales[salesById].attributes.name || ''
        remapDataSales = {
          id: salesById,
          name: salesByName
        }
      } else {
        remapDataSales = {
          id: null,
          name: 'No Sales Team'
        }
      }
      salesMemoryCache[orderId] = remapDataSales
      setDetailUserSales(remapDataSales)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUserSales(false)
    }
  }

  const handleGetDetailUser = async(userId) => {
    if (userMemoryCache[userId]) {
      return userMemoryCache[userId]
    }
    try {
      const response = await getDetailUser(userId)
      const dataUser = response.data.attributes
      const remapData = {
        id: dataUser.id,
        name: dataUser.name
      }
      userMemoryCache[userId] = remapData
      return remapData
    } catch (error) {
      console.log(error)
    }
  }

  const handlingUpdateShowAsPound = async (value) => {
    const payload = {
      show_as_pound: value
    }
    try {
      const response = await updateOrder(summary.orderId, payload)
      if (response.success) {
        // dispatch(getOrderDetail(summary.orderId))
        const updatedGeneral = {
          ...general,
          showAsPound: value
        }
        dispatch(updateOrderGeneral(updatedGeneral))
        notificationSuccess(`Update Order Successfully`, `Show as pound has been ${value ? 'enabled' : 'disabled'}`)
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    }
  }

  useEffect(() => {
    if (isLoadingOrder) {
      userMemoryCache = {}
      salesMemoryCache = {}
    }
  }, [isLoadingOrder])

  useEffect(() => {
    if (!isLoadingOrder && summary) {
      if (summary.userId !== null) {
        getDataUser(summary.userId)
      }

      if (summary.createdBy) {
        getDataCreatedUser(summary.createdBy)
      } else {
        setLoadingCreatedUser(false)
        setDetailCreatedUser(defaultDataUser)
      }

      if (summary.updatedBy) {
        getDataUpdatedUser(summary.updatedBy)
      } else {
        setLoadingUpdatedUser(false)
        setDetailUpdatedUser(defaultDataUser)
      } 

      if (summary.agentId) {
        getDataUserAgent(summary.agentId)
      } else {
        setLoadingUserAgent(false)
        setDetailUserAgent(defaultDataUser)
      }

      if (summary.orderId !== null) {
        getDataUserSales(summary.orderId)
      }
    }
    // eslint-disable-next-line
  }, [isLoadingOrder, summary])

  const onCloseFormOrderBy = () => {
    setOpenEditOrderBy(false)
  }

  const onCloseFormAgent = () => {
    setOpenEditAgent(false)
  }

  const onCloseFormSales = () => {
    setOpenEditSales(false)
  }

  const onCloseFormAdditionalInfo = () => {
    setOpenEditAdditionalInfo(false)
  }

  const onCloseFormPaymentStatus = () => {
    setOpenEditPaymentStatus(false)
  }

  const onCloseFormOrderStatus = () => {
    setOpenEditOrderStatus(false)
  }

  const onCloseFormGeneralInfo = () => {
    setOpenEditGeneralInfo(false)
  }

  const onCloseFormOrderExcerpt = () => {
    setOpenEditOrderExcerpt(false)
  }

  const showDataPound = (logisticData) => {
    const dataTotalWeight = logisticData.revisedTotalWeight || logisticData.totalWeight || 0

    const convertDataPound = Number(dataTotalWeight) * 2.20462

    return `${convertDataPound.toFixed(3)} pound`
  } 

  const handleCustomerNeedToPay = (paymentStatus) => {
    const totalProductCost = logistic.totalProductOriginalCost || 0
    const totalCustomCharges = logistic.revisedTotalCustomCharges
      || logistic.totalCustomCharges
      || 0
    const totalLogisticCharges = logistic.totalLogisticCharges || 0
    const grandTotal = summary.grandTotal || 0
    const orderType = summary.type

    if (paymentStatus === 'unpaid balance') {
      const result = {
        amount: totalProductCost + totalCustomCharges + totalLogisticCharges,
        formula: 'Total Product Cost + Total Custom Charges + Total Logistic Charges',
      }
      return result
    } else if (paymentStatus === 'unpaid goods') {
      const result = {
        amount: totalProductCost,
        formula: 'Total Product Cost',
      }
      return result
    } else if (paymentStatus === 'unpaid logistic all in') {
      const result = {
        amount: totalCustomCharges + totalLogisticCharges,
        formula: 'Total Custom Charges + Total Logistic Charges',
      }
      return result
    } else if (paymentStatus === 'unpaid logistic') {
      const result = {
        amount: totalLogisticCharges,
        formula: 'Total Logistic Charges',
      }
      return result
    } else if (paymentStatus === 'paid goods only') {
      const result = {
        amount: grandTotal,
        formula: 'Grand Total',
      }
      return result
    } else if (paymentStatus === 'paid all') {
      if (orderType === 'forwarding') {
        return {
          amount: totalCustomCharges + totalLogisticCharges,
          formula: 'Total Custom Charges + Total Logistic Charges',
        }
      }

      const result = {
        amount: grandTotal,
        formula: 'Grand Total',
      }
      return result
    } else {
      return 0
    }
  }

  const stateDiscountData = (stateDiscount) => {
    if (stateDiscount) {
      return (
        <Box>
          <Text fz={14} fw={500} c='blue.8'> - <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.coupons[0].discount} /></Text>
        </Box>
      )
    } else {
      return (
        <Box>
          <Text fz={14} fw={500} c='blue.8'> - <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={0} /></Text>
        </Box>
      )
    }
  }

  return (
    <Box>
      <Box my={20}>
        <Box>
          <SimpleGrid cols={5} verticalSpacing="md">
            <Box>
              <Flex align='center'>
                <Text fz={12} c='gray.6'>Order By</Text>
                <ActionIcon variant="transparent" size='md' color='blue' onClick={() => setOpenEditOrderBy(true)}>
                  <IconPencilMinus style={{ width: '70%', height: '70%', marginBottom: '4px' }} stroke={1.5} />
                </ActionIcon>
              </Flex>
              <Box>
                {isLoadingOrder || loadingUser ? <Skeleton height={14} mt={6} width="40%" radius="xl" /> : <Text fz={14} fw='500' lineClamp={2}>{detailUser.name}</Text>}
                <Text fz={10} c='gray.6'>{dayjs(summary.orderDate).format('DD/MMMM/YYYY')} - { dayjs(summary.orderDate).format('HH:mm:ss')}</Text>
              </Box>
            </Box>
            <Box>
              <Flex align='center' mb={10}>
                <Text fz={12} c='gray.6'>Created By</Text>
              </Flex>
              <Box>
                {isLoadingOrder || loadingCreatedUser ? <Skeleton height={14} mt={6} width="40%" radius="xl" /> : <Text fz={14} fw='500' lineClamp={2}>{detailCreatedUser.id !== null ? detailCreatedUser.name : 'No User'}</Text>}
                <Text fz={10} c='gray.6'>{dayjs(summary.createdAt).format('DD/MMMM/YYYY')} - { dayjs(summary.createdAt).format('HH:mm:ss')}</Text>
              </Box>
            </Box>
            <Box>
              <Flex align='center' mb={10}>
                <Text fz={12} c='gray.6'>Updated By</Text>
              </Flex>
              <Box>
                {isLoadingOrder || loadingUpdatedUser ? <Skeleton height={14} mt={6} width="40%" radius="xl" /> : <Text fz={14} fw='500' lineClamp={2}>{detailUpdatedUser.id !== null ? detailUpdatedUser.name : 'No User'}</Text>}
                <Text fz={10} c='gray.6'>{dayjs(summary.updatedAt).format('DD/MMMM/YYYY')} - { dayjs(summary.updatedAt).format('HH:mm:ss')}</Text>
              </Box>
            </Box>
            <Box>
              <Flex align='center'>
                <Text fz={12} c='gray.6'>Agent</Text>
                <ActionIcon variant="transparent" size='md' color='blue' onClick={() => setOpenEditAgent(true)}>
                  <IconPencilMinus style={{ width: '70%', height: '70%', marginBottom: '4px' }} stroke={1.5} />
                </ActionIcon>
              </Flex>
              <Box>
                {isLoadingOrder || loadingUserAgent ? <Skeleton height={14} mt={6} width="40%" radius="xl" /> : <Text fz={14} fw='500' lineClamp={2}>{detailUserAgent.id !== null ? detailUserAgent.name : 'No Agent'}</Text>}
              </Box>
            </Box>
            <Box>
              <Flex align='center'>
                <Text fz={12} c='gray.6'>Sales By</Text>
                <ActionIcon variant="transparent" size='md' color='blue' onClick={() => setOpenEditSales(true)}>
                  <IconPencilMinus style={{ width: '70%', height: '70%', marginBottom: '4px' }} stroke={1.5} />
                </ActionIcon>
              </Flex>
              <Box>
                {isLoadingOrder || loadingUserSales ? <Skeleton height={14} mt={6} width="40%" radius="xl" /> : <Text fz={14} fw='500' lineClamp={2}>{detailUserSales.name}</Text>}
              </Box>
            </Box>
          </SimpleGrid>
        </Box>
        <Box my={20}>
          <Grid align='center' overflow='hidden'>
            <Grid.Col span={8}>
              <Paper shadow="xs" p={28} withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditAdditionalInfo(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <SimpleGrid cols={5} verticalSpacing="md" spacing="xs">
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Shipment Method</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{!isLoadingOrder ? shipmentMethod[logistic.shipmentMethod] : ''}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Supplier Name</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{additionalInfo.supplier_name ? additionalInfo.supplier_name : 'No Supplier'}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Order Origin</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{additionalInfo.origin}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Destination</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{additionalInfo.destination}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Batch / Marking Code</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{additionalInfo.marking_code ? additionalInfo.marking_code : 'No batch / marking code'}</Badge>
                  </Box>
                </SimpleGrid>
              </Paper>
            </Grid.Col>
            <Grid.Col span={4}>
              <Paper shadow="xs" p={20.25} withBorder>
                <SimpleGrid cols={2} verticalSpacing="md">
                  <Box pos='relative'>
                    <Box style={{ position: 'absolute', right: '20px', top: '-20px' }}>
                      <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditPaymentStatus(true)}>
                        <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                      </ActionIcon>
                    </Box>
                    <Text fz={12} c='gray.6' mb={4}>Payment Status</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{summary.paymentStatus}</Badge>
                    {summary.paymentStatusDate ? <Text fz={10} c='gray.6'>{dayjs(summary.paymentStatusDate).format('DD/MMMM/YYYY')}</Text> : <Box my={14}/>}
                  </Box>
                  <Box pos='relative'>
                    <Box style={{ position: 'absolute', right: '20px', top: '-20px' }}>
                      <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditOrderStatus(true)}>
                        <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                      </ActionIcon>
                    </Box>
                    <Text fz={12} c='gray.6' mb={4}>Order Status</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{summary.orderStatus}</Badge>
                    {summary.additionalOrderStatus ? <Text fz={10} c='gray.6'>{dayjs(summary.additionalOrderStatus.date).format('DD/MMMM/YYYY')}</Text> : <Box my={14}/>}
                  </Box>
                </SimpleGrid>
              </Paper>
            </Grid.Col>
          </Grid>
        </Box>
        <Box mb={20}>
          <Grid align='center' overflow='hidden'>
            <Grid.Col span={8}>
              <Paper shadow="xs" p={28} withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditGeneralInfo(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <SimpleGrid cols={5} verticalSpacing="md" spacing="xs">
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Type</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{summary.type}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Category</Text>
                    <Badge variant="light" color='black' tt={summary.category === 'cod' ? 'uppercase' : 'capitalize'} fw='500' mb={4}>{summary.category ? summary.category : 'No Category'}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Terms</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{general.terms ? general.terms : 'No Terms'}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Load Type</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{general.loadType ? general.loadType : 'No Load Type'}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Undername</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{general.undername ? general.undername : 'No Undername'}</Badge>
                  </Box>
                </SimpleGrid>
              </Paper>
            </Grid.Col>
            <Grid.Col span={4}>
              <Paper shadow="xs" p={20.25} withBorder>
                <SimpleGrid cols={2} verticalSpacing="md">
                  <Box pos='relative'>
                    <Text fz={12} c='gray.6' mb={4}>Goods Currency Rate</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}><NumberFormatter thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.goodsCurrencyRate} /></Badge>
                    <Text fz={10} c='gray.6'>{summary.goodsCurrency} > {summary.orderCurrency}</Text>
                  </Box>
                  <Box pos='relative'>
                    <Text fz={12} c='gray.6' mb={4}>Custom Currency Rate</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}><NumberFormatter thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.customCurrencyRate} /></Badge>
                  </Box>
                </SimpleGrid>
              </Paper>
            </Grid.Col>
          </Grid>
        </Box>
        <Box mb={20}>
          <Grid align='center' overflow='hidden'>
            <Grid.Col span={6}>
              <Card withBorder shadow="xs" radius="md" padding='md'>
                <Card.Section withBorder inheritPadding py="xs">
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="white" size='lg'>
                      <IconBox style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500}>Products</Text>
                  </Group>
                </Card.Section>
                <Card.Section withBorder inheritPadding py="xs">
                  <Flex justify='space-between' align='center' h={43}>
                    <Group align='center' gap='xs'>
                      <ThemeIcon variant="light" color="blue" radius='xl'>
                        <IconPackage style={{ width: '70%', height: '70%' }} />
                      </ThemeIcon>
                      <Text fz={14} fw={500} c='gray.6'>Total Product Cost</Text>
                    </Group>
                    <Box>
                      <Text fz={14} fw={500} c='blue.8'> <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.totalGoodsValueBeforeDiscount} /></Text>
                      {summary.goodsCurrency !== summary.orderCurrency ? <Text fz={14} fw={500} c='black' ta='right'> (<NumberFormatter prefix={`${summary.goodsCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={(summary.totalGoodsValueBeforeDiscount / summary.goodsCurrencyRate)} />)</Text> : ''}
                    </Box>
                  </Flex>
                </Card.Section>
                <Card.Section withBorder inheritPadding py="xs">
                  <Flex justify='space-between' align='center'>
                    <Group align='center' gap='xs'>
                      <ThemeIcon variant="light" color="blue" radius='xl'>
                        <IconRosetteDiscount style={{ width: '70%', height: '70%' }} />
                      </ThemeIcon>
                      <Text fz={14} fw={500} c='gray.6'>Total Product Discount</Text>
                    </Group>
                    {!isLoadingOrder ? stateDiscountData(summary.coupons.length > 0 && (summary.coupons[0].coupon_type === 'Fixed Goods Discount' || summary.coupons[0].coupon_type === 'Percentage Goods Discount')) : ''}
                  </Flex>
                </Card.Section>
                <Card.Section withBorder inheritPadding py="xs">
                  <SimpleGrid cols={2} spacing="xl">
                    <Flex justify='space-between' align='center'>
                      <Group align='center' gap='xs'>
                        <ThemeIcon variant="light" color="blue" radius='xl'>
                          <IconBox style={{ width: '70%', height: '70%' }} />
                        </ThemeIcon>
                        <Text fz={14} fw={500} c='gray.6'>Total CBM</Text>
                      </Group>
                      <Group gap={!isLoadingOrder ? logistic.revisedTotalCbm ? 4 : 2 : 0} align='center'>
                        {!isLoadingOrder ? <Box className={logistic.revisedTotalCbm ? classes.PulseAnimation : ''}><Text fz={14} td={logistic.revisedTotalCbm ? 'line-through' : ''} c={logistic.revisedTotalCbm ? 'red' : 'black'}>{logistic.totalCbm}</Text></Box> : ''}
                        {!isLoadingOrder ? <Text fz={14} c='black'>{logistic.revisedTotalCbm}</Text> : ''}
                      </Group>
                    </Flex>
                    <Flex justify='space-between' align='center'>
                      <Group align='center' gap='xs'>
                        <ThemeIcon variant="light" color="blue" radius='xl'>
                          <IconWeight style={{ width: '70%', height: '70%' }} />
                        </ThemeIcon>
                        <Text fz={14} fw={500} c='gray.6'>Total Weight</Text>
                      </Group>
                      <Group gap={!isLoadingOrder ? logistic.revisedTotalCbm ? 4 : 2 : 0}  align='center'>
                        {!isLoadingOrder ? <Text fz={14} c='black'>{general.showAsPound ? showDataPound(logistic) : ''}</Text> : ''}
                        {!isLoadingOrder ? <Box className={logistic.revisedTotalWeight ? classes.PulseAnimation : ''}><Text fz={14} td={logistic.revisedTotalWeight ? 'line-through' : ''} c={logistic.revisedTotalWeight ? 'red' : 'black'}>{general.showAsPound ? '(' : ''} {logistic.totalWeight}</Text></Box> : ''}
                        {!isLoadingOrder ? <Text fz={14} c='black'>{logistic.revisedTotalWeight} Kg {general.showAsPound ? ')' : ''}</Text> : ''}
                      </Group>
                    </Flex>
                  </SimpleGrid>
                  <Flex justify='flex-end' mt={6}>
                    <Switch
                      label='Show as pound (pound/lbs)'
                      size='xs'
                      checked={general.showAsPound}
                      onChange={(val) => handlingUpdateShowAsPound(val.target.checked)}
                      loading={true}
                    />
                  </Flex>
                </Card.Section>
                <Card.Section withBorder inheritPadding py="xs">
                  <Flex justify='space-between' align='flex-start' h={50}>
                    <Group align='center' gap='xs'>
                      <Text fz={14} fw={500} c='black'>Total Product Cost</Text>
                    </Group>
                    <Box>
                      <Text fz={16} fw='bold' c='red'> <NumberFormatter prefix='Rp ' thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.totalGoodsValueBeforeDiscount} /></Text>
                      {summary.goodsCurrency !== summary.orderCurrency ? <Text fz={14} fw={500} c='black' ta='right'> (<NumberFormatter prefix={`${summary.goodsCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={(summary.totalGoodsValueBeforeDiscount / summary.goodsCurrencyRate)} />)</Text> : ''}
                    </Box>
                  </Flex>
                </Card.Section>
              </Card>
            </Grid.Col>
            <Grid.Col span={6}>
              <Card withBorder shadow="xs" radius="md" padding='md'>
                <Card.Section withBorder inheritPadding py="xs">
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="white" size='lg'>
                      <IconCashBanknote style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500}>Logistic All In</Text>
                  </Group>
                </Card.Section>
                <Card.Section withBorder inheritPadding py={17.5}>
                  <Flex justify='space-between' align='center'>
                    <Group align='center' gap='xs'>
                      <ThemeIcon variant="light" color="blue" radius='xl'>
                        <IconShoppingCart style={{ width: '70%', height: '70%' }} />
                      </ThemeIcon>
                      <Text fz={14} fw={500} c='gray.6'>Total Custom Charge</Text>
                    </Group>
                    <Group gap={!isLoadingOrder ? logistic.revisedTotalCustomCharges ? 4 : 2 : 0}  align='center'>
                      {!isLoadingOrder ? <Box className={logistic.revisedTotalCustomCharges ? classes.PulseAnimation : ''}><Text fz={14} td={logistic.revisedTotalCustomCharges ? 'line-through' : ''} c={logistic.revisedTotalCustomCharges ? 'red' : 'blue.8'}>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={logistic.totalCustomCharges} />}</Text></Box> : ''}
                      {!isLoadingOrder ? logistic.revisedTotalCustomCharges ? <Text fz={14} c='blue.8'>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={logistic.revisedTotalCustomCharges} />}</Text> : '' : ''}
                    </Group>
                  </Flex>
                </Card.Section>
                <Card.Section withBorder inheritPadding py="xs">
                  <Flex justify='space-between' align='center'>
                    <Group align='center' gap='xs'>
                      <ThemeIcon variant="light" color="blue" radius='xl'>
                        <IconShoppingCart style={{ width: '70%', height: '70%' }} />
                      </ThemeIcon>
                      <Text fz={14} fw={500} c='gray.6'>Total Logistic Charge</Text>
                    </Group>
                    <Box>
                      {!isLoadingOrder ? <Text fz={14} c='blue.8'>{<NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.totalLogisticChargesBeforeDiscount} />}</Text> : ''}
                    </Box>
                  </Flex>
                </Card.Section>
                <Card.Section withBorder inheritPadding py="xs">
                  <Flex justify='space-between' align='center'>
                    <Group align='center' gap='xs'>
                      <ThemeIcon variant="light" color="blue" radius='xl'>
                        <IconRosetteDiscount style={{ width: '70%', height: '70%' }} />
                      </ThemeIcon>
                      <Text fz={14} fw={500} c='gray.6'>Total Logistic Discount</Text>
                    </Group>
                    {!isLoadingOrder ? stateDiscountData(summary.coupons.length > 0 && (summary.coupons[0].coupon_type === 'Fixed Goods Discount' || summary.coupons[0].coupon_type === 'Percentage Goods Discount')) : ''}
                  </Flex>
                  <Box h={22} />
                </Card.Section>
                <Card.Section withBorder inheritPadding py="xs">
                  <Flex justify='space-between' align='flex-start' h={50}>
                    <Group align='center' gap='xs'>
                      <Text fz={14} fw={500} c='black'>Total Logistic All In</Text>
                    </Group>
                    <Box mb={20.5}>
                      {!isLoadingOrder ? <Text fz={16} fw='bold' c='red'> <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={logistic.totalLogisticCharges + (logistic.revisedTotalCustomCharges || logistic.totalCustomCharges)} /></Text> : ''}
                    </Box>
                  </Flex>
                </Card.Section>
              </Card>
            </Grid.Col>
          </Grid>
        </Box>
        <Box mb={20}>
          <Paper shadow="xs" p='md' withBorder>
            <SimpleGrid cols={4}>
              <Box>
                <Text fz={16} fw='bold' c='black' mb={6}>Grand Total </Text>
                {!isLoadingOrder ? <Title order={2} fw={600} c='red'><NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.grandTotal} /></Title> : ''}
              </Box>
              <Box>
                <Flex align='center' mb={!isLoadingOrder ? handleCustomerNeedToPay(summary.paymentStatus).formula ? 3 : 6 : ''}>
                  <Text fz={16} fw='bold' c='black'>You Need To Pay </Text>
                  {!isLoadingOrder ? handleCustomerNeedToPay(summary.paymentStatus).formula ? <Tooltip label={handleCustomerNeedToPay(summary.paymentStatus).formula}><ThemeIcon variant="white" color="blue" radius='xl'><IconInfoCircle style={{ width: '70%', height: '70%' }} /></ThemeIcon></Tooltip> : '' : ''}
                </Flex>
                {!isLoadingOrder ? <Title order={2} fw={600} c='blue'><NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={handleCustomerNeedToPay(summary.paymentStatus).amount || 0} /></Title> : ''}
              </Box>
              <Box>
                <Text fz={16} fw='bold' c='black' mb={8}>Total Have Been Paid </Text>
                {!isLoadingOrder ? <Title order={2} fw={600} c='green'><NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.totalHaveBeenPaid} /></Title> : ''}
              </Box>
              <Box>
                <Text fz={16} fw='bold' c='black' mb={8}>Remaining Balance </Text>
                {!isLoadingOrder ? <Title order={2} fw={600} c='black'><NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={(handleCustomerNeedToPay(summary.paymentStatus).amount - summary.totalHaveBeenPaid) || 0} /></Title> : ''}
              </Box>
            </SimpleGrid>
          </Paper>
        </Box>
        <Box mb={20}>
          <SimpleGrid cols={2}>
            <Paper shadow="xs" p='md' withBorder>
              <Group justify='space-between' align='center'>
                <Text fz={14} fw='bold' c='black'>Order Excerpt </Text>
                <Group gap={3}>
                  <Text fz={12} c='gray.6' lineClamp={2}>{summary.excerpt ? summary.excerpt : 'Write a order excerpt (optional) '}</Text>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditOrderExcerpt(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Group>
              </Group>
            </Paper>
            <Paper shadow="xs" p='md' withBorder>
              <Group align='center' gap={6}>
                <Group align='center' gap={4}>
                  <ActionIcon variant="light" size='md' radius='xl' color='blue'>
                    <IconWallet style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                  <Text fz={14} fw='bold' c='black'>COD Profits </Text>
                </Group>
                <Text fz={16} fw='bold' c='red'> <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.codProfit !== null || summary.codProfit !== '' ? summary.codProfit : 0} /></Text>
                <Tooltip multiline w={450} withArrow label='Profit yang di dapatkan oleh user dimana profit ini user tambahkan/tentukan pada proses checkout dengan opsi pengiriman COD. Profit ini berlaku jika digunakan untuk pesanan orang lain (Dropship COD)'><ThemeIcon variant="white" color="blue" radius='xl'><IconInfoCircle style={{ width: '70%', height: '70%' }} /></ThemeIcon></Tooltip>
              </Group>
            </Paper>
          </SimpleGrid>
        </Box>
      </Box>
      <Drawer position='right' title='Change order by' opened={openEditOrderBy} onClose={onCloseFormOrderBy} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustOrderBy onCloseForm={onCloseFormOrderBy} />
      </Drawer>
      <Drawer position='right' title='Edit agent' opened={openEditAgent} onClose={onCloseFormAgent} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustAgent onCloseForm={onCloseFormAgent} />
      </Drawer>
      <Drawer position='right' title='Edit sales by' opened={openEditSales} onClose={onCloseFormSales} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustSales detail={detailUserSales} onCloseForm={onCloseFormSales} />
      </Drawer>
      <Drawer position='right' title='Update additional info' opened={openEditAdditionalInfo} onClose={onCloseFormAdditionalInfo} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustAdditionalInfo onCloseForm={onCloseFormAdditionalInfo} />
      </Drawer>
      <Drawer position='right' title='Update payment status' opened={openEditPaymentStatus} onClose={onCloseFormPaymentStatus} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustPaymentStatus onCloseForm={onCloseFormPaymentStatus} />
      </Drawer>
      <Drawer position='right' title='Update order status' size='xl' opened={openEditOrderStatus} onClose={onCloseFormOrderStatus} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustOrderStatus onCloseForm={onCloseFormOrderStatus} />
      </Drawer>
      <Drawer position='right' title='Update general info' opened={openEditGeneralInfo} onClose={onCloseFormGeneralInfo} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustGeneralInfo onCloseForm={onCloseFormGeneralInfo} />
      </Drawer>
      <Drawer position='right' title='Edit Order Excerpt' opened={openEditOrderExcerpt} onClose={onCloseFormOrderExcerpt} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustOrderExcerpt onCloseForm={onCloseFormOrderExcerpt} />
      </Drawer>
    </Box>
  )
}

export default OrderSummary